import React from 'react';
import { Card, CardContent } from '../../components/ui/Card';
import { Button } from '../../components/ui/Button';
import SafeIcon from '../../common/SafeIcon';

export const Contact = () => {
  return (
    <div className="py-24 bg-white min-h-screen">
      <div className="max-w-7xl mx-auto px-6">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-20 items-start">
          <div className="space-y-12">
            <div className="space-y-6">
              <h1 className="text-5xl md:text-6xl font-black text-slate-900 uppercase tracking-tighter leading-none">
                Ta <span className="text-indigo-600">Kontakt</span>
              </h1>
              <p className="text-xl text-slate-500 font-medium leading-relaxed">
                Vi hjelper virksomheter med kartlegging, analyse, workshops og utvikling av psykososialt arbeidsmiljø. Ingen utfordring er for liten eller for stor.
              </p>
            </div>

            <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
              <div className="space-y-4">
                <div className="w-12 h-12 rounded-2xl bg-slate-50 flex items-center justify-center text-indigo-600 shadow-sm">
                  <SafeIcon name="Mail" size={24} />
                </div>
                <div>
                  <h4 className="font-bold text-slate-900">E-post</h4>
                  <p className="text-slate-500">post@hms-innsikt.no</p>
                </div>
              </div>
              <div className="space-y-4">
                <div className="w-12 h-12 rounded-2xl bg-slate-50 flex items-center justify-center text-indigo-600 shadow-sm">
                  <SafeIcon name="Phone" size={24} />
                </div>
                <div>
                  <h4 className="font-bold text-slate-900">Telefon</h4>
                  <p className="text-slate-500">+47 22 33 44 55</p>
                </div>
              </div>
              <div className="space-y-4">
                <div className="w-12 h-12 rounded-2xl bg-slate-50 flex items-center justify-center text-indigo-600 shadow-sm">
                  <SafeIcon name="MapPin" size={24} />
                </div>
                <div>
                  <h4 className="font-bold text-slate-900">Kontor</h4>
                  <p className="text-slate-500">Oslo, Norge</p>
                </div>
              </div>
              <div className="space-y-4">
                <div className="w-12 h-12 rounded-2xl bg-slate-50 flex items-center justify-center text-indigo-600 shadow-sm">
                  <SafeIcon name="ArrowRight" size={24} />
                </div>
                <div>
                  <h4 className="font-bold text-slate-900">Org.nr</h4>
                  <p className="text-slate-500">999 888 777</p>
                </div>
              </div>
            </div>
          </div>

          <Card className="border-none shadow-3xl bg-slate-900 text-white rounded-[64px] overflow-hidden">
            <CardContent className="p-16">
              <h3 className="text-3xl font-black uppercase tracking-tight mb-8">Send oss en melding</h3>
              <form className="space-y-6">
                <div className="space-y-2">
                  <label className="text-[10px] font-black text-slate-500 uppercase tracking-widest ml-1">Ditt Navn</label>
                  <input type="text" className="w-full px-6 py-4 bg-white/5 border border-white/10 rounded-2xl text-white focus:border-indigo-500 outline-none transition-all" placeholder="Navn..." />
                </div>
                <div className="space-y-2">
                  <label className="text-[10px] font-black text-slate-500 uppercase tracking-widest ml-1">E-postadresse</label>
                  <input type="email" className="w-full px-6 py-4 bg-white/5 border border-white/10 rounded-2xl text-white focus:border-indigo-500 outline-none transition-all" placeholder="navn@firma.no" />
                </div>
                <div className="space-y-2">
                  <label className="text-[10px] font-black text-slate-500 uppercase tracking-widest ml-1">Melding</label>
                  <textarea rows="5" className="w-full px-6 py-4 bg-white/5 border border-white/10 rounded-2xl text-white focus:border-indigo-500 outline-none transition-all" placeholder="Hva kan vi hjelpe deg med?"></textarea>
                </div>
                <Button className="w-full py-6 text-sm font-black uppercase tracking-widest bg-indigo-600 hover:bg-indigo-500 border-none shadow-2xl shadow-indigo-500/20">
                  Send Melding
                </Button>
              </form>
            </CardContent>
          </Card>
        </div>
      </div>
    </div>
  );
};